import Vue from "vue";
import moment from "moment";
Vue.filter("dateFromNow", (value) => {
  return value ? moment(value).locale("pt-br").fromNow() : "";
});
